import { metricKeys } from '@pulse/metrics';

// preview images
import PreviewSPI from '@images/widgets/video-spi.png';
import PreviewOpp from '@images/widgets/video-opp.png';
import PreviewStreams from '@images/widgets/video-streams.png';
import PreviewMetricGroup from '@images/widgets/metric-group.png';
import PreviewViewers from '@images/widgets/video-viewers.png';

// TODO: move constants to common section

import { buildWidgetConfig } from '../state/utils';
import { AVAILABILITY, GLOBAL_MAX_WIDGETS_ALLOWED } from './constants';

export const EI_WIDGET_TYPES = {
  streamingPerformanceIndex: 'spi',
  improvementOpportunities: 'improvement-opportunities',
  streams: 'streams',
  metricGroup: 'metric-group',
  viewers: 'viewers',
};

export const EI_WIDGET_LIST = [
  {
    type: EI_WIDGET_TYPES.streamingPerformanceIndex,
    meta: {
      title: 'SPI',
      limit: 1, // only one copy of the widget is allowed
      context: ['any'], // list always
      preview: PreviewSPI,
      availability: AVAILABILITY.GA,
    },
    state: {},
  },
  {
    type: EI_WIDGET_TYPES.improvementOpportunities,
    meta: {
      title: 'Improvement Opportunities',
      limit: 1,
      context: ['any'],
      preview: PreviewOpp,
      availability: AVAILABILITY.GA,
    },
    state: {},
  },
  {
    type: EI_WIDGET_TYPES.streams,
    meta: {
      title: 'Streams',
      limit: 1,
      context: ['any'],
      preview: PreviewStreams,
      availability: AVAILABILITY.GA,
    },
    state: {},
  },
  {
    type: EI_WIDGET_TYPES.metricGroup,
    meta: {
      title: 'Metric Group',
      limit: GLOBAL_MAX_WIDGETS_ALLOWED,
      context: ['any'], // list always
      preview: PreviewMetricGroup,
      availability: AVAILABILITY.GA,
    },
    state: {
      groupName: 'Metric Group',
      metrics: [],
    },
  },
  {
    type: EI_WIDGET_TYPES.viewers,
    meta: {
      title: 'Viewers',
      limit: 1, // only one copy of the widget is allowed
      context: ['any'], // list always
      preview: PreviewViewers,
      availability: AVAILABILITY.GA,
    },
    state: {},
  },
];

export const EI_WIDGET_TYPE_MAP = {};
Object.values(EI_WIDGET_LIST).forEach((w) => {
  EI_WIDGET_TYPE_MAP[w.type] = w;
});

// configure default widgets, customize state if required
export const eiDefaultWidgets = {};
[
  {
    ...EI_WIDGET_TYPE_MAP[EI_WIDGET_TYPES.metricGroup],
    state: {
      groupName: 'Audience',
      metrics: [metricKeys.ConcurrentPlays, metricKeys.Plays],
    },
  },
  EI_WIDGET_TYPE_MAP[EI_WIDGET_TYPES.streamingPerformanceIndex],
  EI_WIDGET_TYPE_MAP[EI_WIDGET_TYPES.improvementOpportunities],
  EI_WIDGET_TYPE_MAP[EI_WIDGET_TYPES.metricGroup],
  EI_WIDGET_TYPE_MAP[EI_WIDGET_TYPES.streams],
].forEach((widget) => {
  const widgetConfig = buildWidgetConfig({ type: widget.type, state: widget.state });
  eiDefaultWidgets[widgetConfig.wid] = widgetConfig;
});
